import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Tag} from 'antd'
import { EditOutlined, QuestionCircleFilled, DeleteOutlined, CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined, } from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import FormModal from './FormModal'
const {confirm} = Modal

@inject('marketingSmsTemplateStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
  }

  componentDidMount() {
  }
  handleEdit = (record) => {
    const {marketingSmsTemplateStore} = this.props
    marketingSmsTemplateStore.onGetAction(record.id).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const {marketingSmsTemplateStore, t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        marketingSmsTemplateStore.onDeleteAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {marketingSmsTemplateStore} = this.props
    marketingSmsTemplateStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {marketingSmsTemplateStore, type, t} = this.props
    const {pageNo, pageSize, itemCount, jobList, statusList, signList} = marketingSmsTemplateStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} scroll={{x: '110%'}} bordered>
          <Table.Column width={100} title={t(`marketingManagement.marketingGroup`)} dataIndex="marketingGroupName" key="marketingGroupName" ellipsis={true} />
          <Table.Column width={180} title={t(`marketingManagement.templateName`)} dataIndex="templateName" key="templateName" ellipsis={true} />
          <Table.Column width={120} title={t(`marketingManagement.status`)} dataIndex="status" key="status" ellipsis={true} render={(text, record) =>
            <Tag  color={text===1 ? "success" : text===3 ? "error" : "blue" }>
              {text ? text===1 ? <CheckCircleOutlined /> : text===3 ? <CloseCircleOutlined /> :<ClockCircleOutlined /> : null}
              {' '}
              {statusList?.find(a=>parseInt(a?.code)===text)?.name}
            </Tag>
          } />
          <Table.Column title={t(`marketingManagement.templateContent`)} dataIndex="template" key="template" ellipsis={true} render={(text, record) =>
            type ==='1' ? `【${signList?.find(a=>a?.id===record?.signId)?.sign}】 ${text} ${record?.templateSuffix}` : `【${signList?.find(a=>a?.id===record?.signId)?.sign}】 ${text}`
          } />
          <Table.Column width={80} title={t(`marketingManagement.wordsSum`)} dataIndex="characterNum" key="characterNum" ellipsis={true}/>
          <Table.Column width={80} title={t(`marketingManagement.usageSum`)} dataIndex="usageRate" key="usageRate" ellipsis={true}/>
          <Table.Column width={80} title={t(`marketingManagement.sendSum`)} dataIndex="transportVolume" key="transportVolume" ellipsis={true}/>
          {/* <Table.Column title={t(`marketingManagement.daySendSum`)} dataIndex="sendLimit" key="sendLimit" ellipsis={true}/> */}
          <Table.Column title={t(`marketingManagement.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
          <Table.Column width={120} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
          type={type}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
